/**
 * @file Standard DataComponent pagination.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { AfterViewInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AbstractBase } from '../../core/helpers/abstract-base';
/** Standard pagination for DataComponents. */
var PaginationComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PaginationComponent, _super);
    /**
     * Constructs a pagination component.
     * @param router The router for getting en setting the page query parameter.
     */
    function PaginationComponent(router) {
        var _this = _super.call(this) || this;
        _this.router = router;
        /**
         * Gets sets the current page value when in overlayMode.
         * @private
         */
        _this.currentInOverlay = 0;
        /**
         * Gets, sets the overlayMode flag.
         * The overlayMode prohibits changing the uri.
         */
        _this.overlayMode = false;
        /** Gets, sets the total number of retrievable items. */
        _this.totalItems = undefined;
        /** Gets, sets an array of page indexes of all the available pages. */
        _this.availablePages = [0];
        /** The name of the current page index query parameter. */
        _this.pageParam = 'page';
        /** Field representing the maximum page size. */
        _this._pageSize = 5;
        /** Field holding the DataComponent being paged. */
        _this._dataSet = null;
        return _this;
    }
    Object.defineProperty(PaginationComponent.prototype, "currentPage", {
        /** Gets the index of the current page */
        get: function () {
            if (this.overlayMode) {
                return this.currentInOverlay;
            }
            var params = JSON.parse(JSON.stringify(this.router.routerState.root.snapshot.queryParams).toLowerCase());
            var value = params[this.pageParam];
            if (value === undefined || value === null) {
                return 0;
            }
            return Number.parseInt(value) - 1;
        },
        /** Sets the index of the current page */
        set: function (value) {
            var current = this.currentPage;
            if (current === value) {
                return;
            }
            if (this.overlayMode) {
                this.currentInOverlay = value;
                return;
            }
            var params = JSON.parse(JSON.stringify(this.router.routerState.root.snapshot.queryParams).toLowerCase());
            params[this.pageParam] = (value + 1).toString(); // User friendly page number in uri.
            this.router.navigate([], { queryParams: params });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaginationComponent.prototype, "pageSize", {
        /** Sets the maximum number of items per page. */
        set: function (value) {
            if (this._pageSize === value) {
                return;
            }
            this._pageSize = value;
            if (this.totalItems) {
                this.calculateAvailablePages(this.totalItems);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaginationComponent.prototype, "dataSet", {
        /** Sets the DataComponent being paged. */
        set: function (value) {
            var _this = this;
            this._dataSet = value;
            if (!this._dataSet) {
                return;
            }
            this.subscriptionPool.add(this._dataSet.onRefresh.subscribe(function (result) {
                _this.calculateAvailablePages(result.inlineCount);
                _this.setPage(_this.currentPage);
            }));
        },
        enumerable: true,
        configurable: true
    });
    /** Callback when pagination is destroyed to cleanup references. */
    PaginationComponent.prototype.ngOnDestroy = function () {
        this.subscriptionPool.unsubscribeAll();
        this._dataSet = null;
    };
    /** Lifecycle hook that is called after a component's view has been fully initialized. */
    PaginationComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.overlayMode) {
            return;
        }
        this.subscriptionPool.add(this.router.events.subscribe(function (event) {
            if (event instanceof NavigationEnd) {
                window.setTimeout(function () {
                    _this.setPage(_this.currentPage);
                }, 500);
            }
        }));
    };
    /**
     * Load the previous subset for paging.
     */
    PaginationComponent.prototype.previousPage = function () {
        this.setPage(this.currentPage - 1);
    };
    /**
     * Load the next subset for paging.
     */
    PaginationComponent.prototype.nextPage = function () {
        this.setPage(this.currentPage + 1);
    };
    /**
     * Tries to set a new current page index.
     * @param index The page index.
     */
    PaginationComponent.prototype.setPage = function (index) {
        if (!this._dataSet) {
            return;
        }
        if (index < 0 && index >= this.availablePages.length) {
            return;
        }
        var dataSet_skip = this._dataSet.queryOptions.skip == null ? 0 : this._dataSet.queryOptions.skip;
        var skip = this._dataSet.queryOptions.take * index;
        if (dataSet_skip !== skip) {
            this._dataSet.queryOptions.skip = skip;
            this._dataSet.refresh();
        }
        this.currentPage = index;
    };
    /**
     * Calculate the available pages (for rendering of the pagination)
     * @param inlineCount Total number of checklist in query
     */
    PaginationComponent.prototype.calculateAvailablePages = function (inlineCount) {
        // Empty availabe pages array
        this.availablePages.length = 0;
        this.totalItems = (inlineCount) ? inlineCount : 0;
        // No checklist at all, add one page
        if (!inlineCount) {
            this.availablePages.push(0);
            return;
        }
        // Create the pages
        var totalPages = Math.ceil(this.totalItems / this._pageSize);
        for (var i = 0; i < totalPages; i += 1) {
            this.availablePages.push(i);
        }
        if (this.currentPage !== 0 && this.currentPage >= totalPages) {
            this.setPage(0);
        }
    };
    return PaginationComponent;
}(AbstractBase));
export { PaginationComponent };
